const SET_VERIFIED_OFFERS = (state, verifiedOffers) => {
  state.verifiedOffers = verifiedOffers
}

export default {
  SET_VERIFIED_OFFERS,
}
